
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogActions,
    DialogContent,
    Slide,
    Paper,
    TextField
} from "@mui/material";
import {PaperProps} from "@mui/material/Paper";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        RecordModel,
        ActionModel} from '../../models/models';
import {ScreenElementChartFactory} from '../../models/modelsDashboard';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {ChartComponent} from "./../../components/dashboard/Chart";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import {DuplicateListComponent} from "./DuplicateList";
import {AsyncTaskInformationComponent} from "./asyncTasks/AsyncTaskInformation";
import {ShareComponent} from "./Share";
import {EmailTemplatePreviewComponent} from "./emails/EmailTemplatePreview";
import {EmailCampaignPreviewComponent} from "./emails/EmailCampaignPreview";
import {CreateRelatedRecordComponent} from "./CreateRelatedRecord";
import {SendEmailComponent} from "./emails/SendEmail";
import { CartAComponent } from "./../carts/CartA";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from 'react-draggable';
import {Resizable} from 're-resizable';


const PaperComponent = (props: PaperProps) => {
  const nodeRef = React.useRef<HTMLDivElement>(null)
  return (
    <Draggable
      nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  )
}

export const ActionComponent: React.FC<{
  selectedAction: ActionModel,
  closeAction: () => void,
  data: any
}> = ({
  selectedAction,
  closeAction,
  data
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();


  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  useEffect(() => {
    if(data){
      setOpenDialog(true);
    } else {
      setOpenDialog(false);
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps


  const onCloseDialog = (event: any) => {
    setOpenDialog(false)
  }

  const renderChart = () => {
    const thisChart = new ScreenElementChartFactory().fromJSON(data)
    return (
      <DialogContent>
        <ChartComponent
          data={thisChart}
        />
      </DialogContent>
    )
  }

/*
OLD VERSION: NO DRAGGABLE DIALOG
return (
    <Dialog
          open={openDialog}
          onClose={onCloseDialog}
          fullWidth
          maxWidth={'lg'}
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '70vh'
            }
          }}
    >
*/
   return (
    <Dialog
          open={openDialog}
          onClose={onCloseDialog}
          fullWidth
          maxWidth={'lg'}
          PaperComponent={PaperComponent}
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '70vh'
            }
          }}
    >

    <DialogTitle
      id='draggable-dialog-title'
      style={{cursor: 'move'}}
    >
      <Toolbar sx={{justifyContent: 'space-between'}}>
         <Typography variant="h6">
            {selectedAction.Label_sys}
         </Typography>

         <IconButton
            edge="start"
            color="inherit"
            onClick={onCloseDialog}
            aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </DialogTitle>

    <Box sx={{height: '100%', overflow:'auto'}}>

    {selectedAction.OnSuccess_sys.component === "<Chart>" &&
      renderChart()
    }

    {selectedAction.OnSuccess_sys.component === "<Share>" &&
     <DialogContent>
       <ShareComponent
          data={data}
          action={selectedAction}
       />
     </DialogContent>
    }

    {selectedAction.OnSuccess_sys.component === "<EmailTemplatePreview>" &&
     <DialogContent>
       <EmailTemplatePreviewComponent
          data={data}
          action={selectedAction}
       />
     </DialogContent>
   }

    {selectedAction.OnSuccess_sys.component === "<EmailCampaignPreview>" &&
     <DialogContent>
       <EmailCampaignPreviewComponent
          data={data}
          action={selectedAction}
       />
     </DialogContent>
   }

    {selectedAction.OnSuccess_sys.component === "<SendEmail>" &&
     <DialogContent>
       <SendEmailComponent
          data={data}
          action={selectedAction}
       />
     </DialogContent>
   }

    {selectedAction.OnSuccess_sys.component === "<DuplicateList>" &&
      <DialogContent>
        <DuplicateListComponent
          data={data}
          action={selectedAction}
          onMerge={closeAction}
        />
      </DialogContent>
    }

    {selectedAction.OnSuccess_sys.component === '<CreateRelatedRecord>' &&
      <DialogContent>
        <CreateRelatedRecordComponent
          data={data}
          action={selectedAction}
          onSave={closeAction}
        />

      </DialogContent>
  }

    {selectedAction.OnSuccess_sys.component === "<AsyncTaskInformation>" &&
      <DialogContent>
        <AsyncTaskInformationComponent
          data={data}
        />
      </DialogContent>
    }

    {selectedAction.OnSuccess_sys.component === "<CartA>" &&
      <DialogContent>
        <CartAComponent
          context={data}
          onSubmit={closeAction}
        />
      </DialogContent>
    }



    </Box>
    </Dialog>

  );

};
